import React from 'react';
import type { IContext } from '../interface/dropdownContext';

const DropdownContext = React.createContext({} as IContext);

export default DropdownContext;
